import React, {PureComponent} from "react"
import styled from "styled-components"

import Button from "@irati/ui/src/Button"

const MockButton = styled(Button).attrs({primary: true})`
  min-width: 150px;
  cursor: initial;
  &:hover {
    background-color: ${({theme}) => theme.colors.primary1};
    border-color: ${({theme}) => theme.colors.primary1};
  }
`

const MockButtonText = styled.div`
  border-radius: 15px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  height: 15px;
  align-self: center;
`

class PlaceholderButton extends PureComponent {
  render() {
    return (
      <MockButton margin="15px 0">
        <MockButtonText />
      </MockButton>
    )
  }
}

export default PlaceholderButton
